var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-container",on:{"click":_vm.toggle}},[_c('span',{class:{'btn-close': _vm.isOpen }},[_vm._v(_vm._s(_vm.isOpen ? '收起' : '展开'))]),_c('i',{class:_vm.isOpen ? 'el-icon-arrow-up btn-close' : 'el-icon-arrow-down'})])
}
var staticRenderFns = []

export { render, staticRenderFns }